import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';


@Pipe({
  name: 'displayDateInUI'
})

export class DisplayDateInUI implements PipeTransform {

  transform(value: Date): any {
    if (value){
      const tmp = moment(value);
      //console.log('displayDateInUI: ' +  moment(value).format('LLL'));
      return {month: tmp.month() + 1, day: tmp.date(), year: tmp.year() };
    }
  }


}


